import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const HelpFilled = props => (
  <SvgIcon viewBox="0 0 18 18" fill="none" {...props}>
    <g opacity="0.8">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={
          `M9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 
          18ZM9.375 13C9.65114 13 9.875 13.2239 9.875 13.5V14.25C9.875 14.5261 9.65114 14.75 9.375 14.75H8.625C8.34886 
          14.75 8.125 14.5261 8.125 14.25V13.5C8.125 13.2239 8.34886 13 8.625 13H9.375ZM6.50121 6.99673L7.24955 
          7.00329C7.52569 7.0057 7.7515 6.78382 7.75392 6.50768L7.75497 6.38766C7.7836 6.05741 8.11117 5.755 8.50479 
          5.755H10.195C10.7804 5.755 11.255 6.22958 11.255 6.815V7.16015C11.255 7.65638 10.8994 8.08128 10.4109 
          8.16868C9.08806 8.40535 8.125 9.55601 8.125 10.8999V11.5C8.125 11.7761 8.34886 12 8.625 12H9.375C9.65114 12 
          9.875 11.7761 9.875 11.5V10.8999C9.875 10.4036 10.2306 9.97872 10.7191 9.89132C12.0419 9.65465 13.005 8.50399 
          13.005 7.16015V6.815C13.005 5.26308 11.7469 4.005 10.195 4.005H8.50479C7.19879 4.005 6.11193 5.00838 6.00779 
          6.31022L6.00562 6.49075L6.0056 6.49237C6.00319 6.7685 6.22507 6.99431 6.50121 6.99673Z`
        }
        fill="currentcolor"
      />
    </g>
  </SvgIcon>
);

export default HelpFilled;
